import { render } from "./TalentBest.vue?vue&type=template&id=1c698472"
import script from "./TalentBest.vue?vue&type=script&lang=js"
export * from "./TalentBest.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__